import axios from 'axios'

const BASE_URL = process.env.REACT_APP_API_URL;
const ICECAT_GET_URL = BASE_URL + "/icecat_product";
const ICECATREFRENCE_GET_URL = BASE_URL + "/icecat_product/refrenceId";
const APPROVED_SINGLE_URL = BASE_URL + "/icecat_product/approvedId";
const ICECAT_DELETE_URL = BASE_URL + "/icecat_product";

export const getIcecat = (searchParams?: string) => {
  return axios.get(ICECAT_GET_URL+ "?" + searchParams );
};

export const getIcecatSingleProduct = (productid: string) => {
  return axios.get(ICECAT_GET_URL + "/" + productid);
};

export const getIcecatReference = (refrenceId: string) => {
  return axios.get(ICECATREFRENCE_GET_URL + "/" + refrenceId);
};

export const singleApprove = (id: string) => {
  return axios.get(APPROVED_SINGLE_URL + "/" + id);
};

export const deleteIcecatProduct = (productid: string) => {
  return axios.get(ICECAT_DELETE_URL + "/" + productid);
};

export const refuseAllIcecat = (data: any) => {
  return axios.post(ICECAT_GET_URL + "/refuseAll", data.ids);
};

export const approveAllIcecat = (data: any) => {
  return axios.post(ICECAT_GET_URL + "/approveAll", data.ids);
};